/* eslint-disable import/prefer-default-export */
export const isTouchDevice = () => !window.matchMedia('(pointer: fine) and (hover: hover)').matches;
